import {
    RESET_TECHNICIAN_NOTIFICATION,
    FETCH_TECHNICIAN_NOTIFICATION,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const technicianNotificationListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_NOTIFICATION:
        return { data: action.payload };
      case RESET_TECHNICIAN_NOTIFICATION:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianNotificationListReducer;
  